// extracted by mini-css-extract-plugin
module.exports = {"fontBold":"ProximaNovaBold","fontRegular":"ProximaNovaRegular","fontSemiBold":"ProximaNovaSemiBold"};